/* eslint-disable no-unused-vars */
import { Buttons } from 'components';
import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Languages } from 'constants/dictionary/languages';
import {
  select_all_countries_flag,
  selectedLocationsList,
  selectTargettingErrorFlag,
} from 'store/selectors';
import { targetingPlacementsActions } from 'store/actions';

const FillLangsBtn = ({ selectedLangs = [], upDateStore }) => {
  const dispatch = useDispatch();
  const selected_locales = useSelector(selectedLocationsList);
  const isSpecificCountries = useSelector(select_all_countries_flag);
  const errorFlag = useSelector(selectTargettingErrorFlag);

  const countriesCodes = useMemo(
    () => selected_locales.map((item) => item.country_code?.toLowerCase()),
    [selected_locales],
  );

  const handleClick = useCallback(() => {
    const newLangs = Languages.languages
      .filter((item) => countriesCodes.includes(item.country_code?.toLowerCase()))
      .map((item) => item.language_code);
    const langsSet = new Set([...newLangs, ...selectedLangs]);
    const newData = [...langsSet.values()];
    upDateStore(newData.join(','));

    dispatch(
      targetingPlacementsActions.updateErrorField({
        errorField: 'languages',
        newValue: false,
      }),
    );
  }, [selected_locales]);

  return (
    <>
      {+isSpecificCountries === 2 && selected_locales.length ? (
        <Buttons.SecondaryNormal id='chooseLang' style={{ width: '100%' }} onClick={handleClick}>
          Fill based on locations
        </Buttons.SecondaryNormal>
      ) : null}
    </>
  );
};

export default FillLangsBtn;
